module.exports = __webpack_public_path__ + "static/media/medical_pattern.0efa345b.svg";